import { formatAnchor } from "../anchors";
import type { YfAnchor } from "@content/prepSchema";

/** All book anchors of an item on one line, then what goes beyond the book in italics. */
export function AnchorLine({
  book,
  beyondBook,
}: {
  book: YfAnchor[];
  beyondBook?: string | undefined;
}) {
  return (
    <p className="text-xs text-ink-600 [overflow-wrap:anywhere] dark:text-ink-400">
      {book.map(formatAnchor).join("; ")}
      {beyondBook && (
        <>
          {" "}
          <em>{beyondBook}</em>
        </>
      )}
    </p>
  );
}
